<div class="position-relative">
    <div class="d-flex justify-content-center align-items-center avatar bg-danger">
        <fa-icon [icon]="exclamationIcon"
                 size="xl"
                 class="position-absolute top-50 start-50 translate-middle text-white"/>
    </div>
</div>
